/**
 * Attachment plumbing for RFQ query threads, kept out of QueryThread.tsx so
 * the component stays under the 500-line limit.
 *
 * Uploads create an RFQDocument (customer-only on the server); downloads must
 * come through the authenticated endpoint because `/media/rfq/**` is
 * hard-blocked as private media.
 */
import { rfqAPI } from '../../lib/api';
import { downloadRfqDocument } from './rfqDocumentFiles';

// The size limit and formatter are shared with line files (CR-6205).
export { MAX_ATTACHMENT_BYTES, formatBytes } from './rfqDocumentFiles';

/**
 * Upload each file as an RFQDocument on `rfqId` and return the new ids.
 * Sequential rather than parallel: a failure part-way through must leave the
 * message unsent with the reason named, not half-attached.
 */
export async function uploadQueryAttachments(rfqId: number, files: File[]): Promise<number[]> {
  const ids: number[] = [];
  for (const file of files) {
    const form = new FormData();
    form.append('rfq', String(rfqId));
    form.append('file', file);
    form.append('document_type', 'other');
    form.append('title', file.name);
    // A boolean missing from multipart reads as False server-side.
    form.append('is_active', 'true');
    const response = await rfqAPI.uploadDocument(form);
    ids.push(response.data.id);
  }
  return ids;
}

/** Fetch the private file as a blob and hand it to the browser as a save. */
export const downloadQueryAttachment = downloadRfqDocument;
